export const prettifyOutput = (response) => {
  const { body } = response;
  const result = [];
  if (typeof body === 'object') {
    if (body.result && typeof body.result === 'object') {
      result.push(`👇 Program output 👇`);
      result.push(
        !Array.isArray(body.result)
          ? JSON.stringify(body.result, null, 2)
          : body.result
      );
    }
    if (body.logs) {
      result.push(`👇 Program logs 👇`);
      result.push(body.logs);
    }
  } else if (typeof body === 'string') {
    result.push(`👇 Program logs 👇`);
    result.push(body);
  }
  return result.join('\n\n');
};

export const INIT_CODE_CODE_NODE = `
import traceback
import xmltodict
import re
import json
import requests as requests_og
import logging
from haptik_code_library.haptik_requests import HaptikRequests
import time
import inspect

def get_logger():
    logger = logging.getLogger()
    logger.setLevel(logging.DEBUG)
    for handler in logger.handlers:
        logger.removeHandler(handler)

    formatter = logging.Formatter('[%(asctime)s][%(levelname)s][LINE_NO:%(lineno)d] %(message)s')
    stream_handler = logging.StreamHandler()
    stream_handler.setFormatter(formatter)
    logger.addHandler(stream_handler)
    return logger


logger = get_logger()

haptik_requests = HaptikRequests()


@haptik_requests.add_api_metadata_to_response()
def main(event, context):
    if isinstance(event, str):
        event = json.loads(event)
    return CodeExecutor(event).execute()


class CodeExecutor:

    def __init__(self, event: dict) -> None:
        self.body = json.loads(event["body"])
        logger.info(self.body)
        self.user = self.body["user"]
        self.entities = self.body["entities"]
        self.env_var = self.body.get("env_variables", {})
        self.user_details = self.body.get("user_details", {})
        self.conversation_details = self.body["conversation_details"]
        self.data = {}
        self.output_data = {}

    def execute(self):
        """
        Explain code here

        POSSIBLE STATUSES:
            SUCCESS
            CODE_BREAK
            TIMEOUT
            API_ERROR

        UPDATES CONVERSATION_DETAILS :
            KEY_NAME

        UPDATES USER_DETAILS:
            KEY_NAME
        """
        status = "SUCCESS"
        try:
            # Write your code here
            # self.sample_api_call_func()
            pass

        except requests_og.exceptions.Timeout:
            logger.exception(traceback.format_exc())
            status = "TIMEOUT"
        except (requests_og.exceptions.ConnectionError, requests_og.exceptions.HTTPError, APIDataError):
            logger.exception(traceback.format_exc())
            status = "API_ERROR"
        except Exception:
            logger.exception(traceback.format_exc())
            status = "CODE_BREAK"

        return self.get_final_response(status=status)  # data passed to output node

    def sample_api_call_func(self):
        """
        DO NOT handle exception for error scenarios here. That is already handled
        """

        url = f"{self.env_var.get('CLIENT_URL')}/url_relative_path/"

        headers = {
            'Authorization': f"Bearer {self.env_var.get('STATIC_TOKEN')}"
        }

        entity_data = self.get_entity('entity_name')

        params = {
            'email': entity_data
        }

        payload = {
            "some key": "some value"
        }

        response = self.api_handler("POST", url, params=params, headers=headers, json=payload, timeout=10)
        some_var = response.get('some_key')

        if not some_var:
            raise APIDataError("Key 'some_key' is not present in API")

        self.data.update({"some_key": some_var})

    def get_entity(self, key, default="", get_original_text=False) -> str:
        entity = self.entities.get(key)
        if entity:
            if get_original_text and entity[0].get('original_text'):
                entity = entity[0].get('original_text', "")
            else:
                entity = entity[0].get('entity_value', "")

            if isinstance(entity, str):
                return entity
            entity = "".join([v for k, v in entity.items() if isinstance(v, str)])
            return entity
        else:
            return default

    def api_handler(self, method, url, handle_error_status_code=None, **kwargs):
        """
        Treat this function as requests library call. You can pass arguments such as headers, data, json, timeout, etc.
        handle_error_status_code:   Pass a function that will take response as argument
                                    and handles non 2XX status
        """
        try:
            request_start_time = time.time()
            logger.info(f"Calling {url} on behalf of function '{inspect.currentframe().f_back.f_code.co_name}'"
                        f"with payload:{kwargs.get('data') or kwargs.get('json')}")
            response = haptik_requests.request(method=method.lower(), url=url, **kwargs)
            logger.info(f"Took {time.time() - request_start_time}sec to call {url},"
                        f"Got status code {response.status_code}")

            if response.status_code is None:
                logger.info(f"Unable to reach URL {url}")
                raise requests_og.exceptions.ConnectionError()
            elif response.ok:
                logger.info(f"[Success] url:{url} response:{response.text}")
                response = self.transform_to_dict(response.text)
                return response
            elif handle_error_status_code is not None:
                return handle_error_status_code(response)
            elif response.status_code == 408:
                raise requests_og.exceptions.Timeout()
            else:
                raise requests_og.exceptions.HTTPError()
        except requests_og.exceptions.Timeout as errt:
            logger.exception(f"[Error] {errt} url:{url}")
            raise
        except (requests_og.exceptions.ConnectionError, requests_og.exceptions.HTTPError) as errc:
            logger.exception(f"[Error] {errc} url:{url}")
            raise
        except Exception as err:
            logger.exception(f"[Error] {err} url:{url}")
            raise

    @staticmethod
    def transform_to_dict(data):
        try:
            return json.loads(data)
        except ValueError:
            try:
                return xmltodict.parse(re.sub(r'xmlns:[^>]*|ns\d+:|SOAP:', '', data))
            except:
                return data

    def get_final_response(self, **kwargs):
        final_response = {
            **kwargs,
            **self.output_data,
            'conversation_details': self.conversation_details,
            'user_details': self.user_details
        }
        logger.info(f"final_response {final_response}")
        return {'statusCode': 200, 'body': json.dumps(final_response), 'headers': {'Content-Type': 'application/json'}}


class APIDataError(Exception):
    pass
`;

export const INIT_CODE_VOICE_AGENT = `import traceback
import xmltodict
import re
import json
import requests as requests_og
import logging
import time
import inspect

def get_logger():
    logger = logging.getLogger()
    logger.setLevel(logging.DEBUG)
    for handler in logger.handlers:
        logger.removeHandler(handler)

    formatter = logging.Formatter('[%(asctime)s][%(levelname)s][LINE_NO:%(lineno)d] %(message)s')
    stream_handler = logging.StreamHandler()
    stream_handler.setFormatter(formatter)
    logger.addHandler(stream_handler)
    return logger


logger = get_logger()



def main(event, context):
    if isinstance(event, str):
        event = json.loads(event)
    return CodeExecutor(event).execute()


class CodeExecutor:

    def __init__(self, event: dict) -> None:
        self.body = json.loads(event["body"])
        logger.info(self.body)
        self.user = self.body["user"]
        self.entities = self.body["entities"]
        self.env_var = self.body.get("env_variables", {})
        self.user_details = self.body.get("user_details", {})
        self.conversation_details = self.body["conversation_details"]
        self.data = {}
        self.output_data = {}

    def execute(self):
        """
        Explain code here

        POSSIBLE STATUSES:
            SUCCESS
            CODE_BREAK
            TIMEOUT
            API_ERROR

        UPDATES CONVERSATION_DETAILS :
            KEY_NAME

        UPDATES USER_DETAILS:
            KEY_NAME
        """
        status = "SUCCESS"
        try:
            # Write your code here
            # self.sample_api_call_func()
            pass

        except requests_og.exceptions.Timeout:
            logger.exception(traceback.format_exc())
            status = "TIMEOUT"
        except (requests_og.exceptions.ConnectionError, requests_og.exceptions.HTTPError, APIDataError):
            logger.exception(traceback.format_exc())
            status = "API_ERROR"
        except Exception:
            logger.exception(traceback.format_exc())
            status = "CODE_BREAK"

        return self.get_final_response(status=status)  # data passed to output node

    def sample_api_call_func(self):
        """
        DO NOT handle exception for error scenarios here. That is already handled
        """

        url = f"{self.env_var.get('CLIENT_URL')}/url_relative_path/"

        headers = {
            'Authorization': f"Bearer {self.env_var.get('STATIC_TOKEN')}"
        }

        entity_data = self.get_entity('entity_name')

        params = {
            'email': entity_data
        }

        payload = {
            "some key": "some value"
        }

        response = self.api_handler("POST", url, params=params, headers=headers, json=payload, timeout=10)
        some_var = response.get('some_key')

        if not some_var:
            raise APIDataError("Key 'some_key' is not present in API")

        self.data.update({"some_key": some_var})

    def get_entity(self, key, default="", get_original_text=False) -> str:
        entity = self.entities.get(key)
        if entity:
            if get_original_text and entity[0].get('original_text'):
                entity = entity[0].get('original_text', "")
            else:
                entity = entity[0].get('entity_value', "")

            if isinstance(entity, str):
                return entity
            entity = "".join([v for k, v in entity.items() if isinstance(v, str)])
            return entity
        else:
            return default

    def api_handler(self, method, url, handle_error_status_code=None, **kwargs):
        """
        Treat this function as requests library call. You can pass arguments such as headers, data, json, timeout, etc.
        handle_error_status_code:   Pass a function that will take response as argument
                                    and handles non 2XX status
        """
        try:
            request_start_time = time.time()
            logger.info(f"Calling {url} on behalf of function '{inspect.currentframe().f_back.f_code.co_name}'"
                        f"with payload:{kwargs.get('data') or kwargs.get('json')}")
            response = requests_og.request(method=method.lower(), url=url, **kwargs)
            logger.info(f"Took {time.time() - request_start_time}sec to call {url},"
                        f"Got status code {response.status_code}")

            if response.status_code is None:
                logger.info(f"Unable to reach URL {url}")
                raise requests_og.exceptions.ConnectionError()
            elif response.ok:
                logger.info(f"[Success] url:{url} response:{response.text}")
                response = self.transform_to_dict(response.text)
                return response
            elif handle_error_status_code is not None:
                return handle_error_status_code(response)
            elif response.status_code == 408:
                raise requests_og.exceptions.Timeout()
            else:
                raise requests_og.exceptions.HTTPError()
        except requests_og.exceptions.Timeout as errt:
            logger.exception(f"[Error] {errt} url:{url}")
            raise
        except (requests_og.exceptions.ConnectionError, requests_og.exceptions.HTTPError) as errc:
            logger.exception(f"[Error] {errc} url:{url}")
            raise
        except Exception as err:
            logger.exception(f"[Error] {err} url:{url}")
            raise

    @staticmethod
    def transform_to_dict(data):
        try:
            return json.loads(data)
        except ValueError:
            try:
                return xmltodict.parse(re.sub(r'xmlns:[^>]*|nsd+:|SOAP:', '', data))
            except:
                return data

    def get_final_response(self, **kwargs):
        final_response = {
            **kwargs,
            **self.output_data,
            'conversation_details': self.conversation_details,
            'user_details': self.user_details
        }
        logger.info(f"final_response {final_response}")
        return {'statusCode': 200, 'body': json.dumps(final_response), 'headers': {'Content-Type': 'application/json'}}


class APIDataError(Exception):
    pass`;

export const INIT_CODE_MULTI_VOICE_AGENT = `import traceback
import xmltodict
import re
import json
import requests as requests_og
import logging
import time
import inspect

def get_logger():
    logger = logging.getLogger()
    logger.setLevel(logging.DEBUG)
    for handler in logger.handlers:
        logger.removeHandler(handler)

    formatter = logging.Formatter('[%(asctime)s][%(levelname)s][LINE_NO:%(lineno)d] %(message)s')
    stream_handler = logging.StreamHandler()
    stream_handler.setFormatter(formatter)
    logger.addHandler(stream_handler)
    return logger


logger = get_logger()



def main(event, context):
    if isinstance(event, str):
        event = json.loads(event)
    return CodeExecutor(event).execute()


class CodeExecutor:

    def __init__(self, event: dict) -> None:
        self.body = json.loads(event["body"])
        logger.info(self.body)
        self.user = self.body["user"]
        self.entities = self.body["entities"]
        self.env_var = self.body.get("env_variables", {})
        self.user_details = self.body.get("user_details", {})
        self.conversation_details = self.body["conversation_details"]
        self.data = {}
        self.output_data = {}

    def execute(self):
        """
        Explain code here

        POSSIBLE STATUSES:
            SUCCESS
            CODE_BREAK
            TIMEOUT
            API_ERROR

        UPDATES CONVERSATION_DETAILS :
            KEY_NAME

        UPDATES USER_DETAILS:
            KEY_NAME
        """
        status = "SUCCESS"
        try:
            # Write your code here
            # self.sample_api_call_func()
            pass

        except requests_og.exceptions.Timeout:
            logger.exception(traceback.format_exc())
            status = "TIMEOUT"
        except (requests_og.exceptions.ConnectionError, requests_og.exceptions.HTTPError, APIDataError):
            logger.exception(traceback.format_exc())
            status = "API_ERROR"
        except Exception:
            logger.exception(traceback.format_exc())
            status = "CODE_BREAK"

        return self.get_final_response(
            status=status,
            format=True,
            response="",
            next_agent="",
            disconnect_call=False,
            parameters={}
        )  # data passed to output node

    def sample_api_call_func(self):
        """
        DO NOT handle exception for error scenarios here. That is already handled
        """

        url = f"{self.env_var.get('CLIENT_URL')}/url_relative_path/"

        headers = {
            'Authorization': f"Bearer {self.env_var.get('STATIC_TOKEN')}"
        }

        entity_data = self.get_entity('entity_name')

        params = {
            'email': entity_data
        }

        payload = {
            "some key": "some value"
        }

        response = self.api_handler("POST", url, params=params, headers=headers, json=payload, timeout=10)
        some_var = response.get('some_key')

        if not some_var:
            raise APIDataError("Key 'some_key' is not present in API")

        self.data.update({"some_key": some_var})

    def get_entity(self, key, default="", get_original_text=False) -> str:
        entity = self.entities.get(key)
        if entity:
            if get_original_text and entity[0].get('original_text'):
                entity = entity[0].get('original_text', "")
            else:
                entity = entity[0].get('entity_value', "")

            if isinstance(entity, str):
                return entity
            entity = "".join([v for k, v in entity.items() if isinstance(v, str)])
            return entity
        else:
            return default

    def api_handler(self, method, url, handle_error_status_code=None, **kwargs):
        """
        Treat this function as requests library call. You can pass arguments such as headers, data, json, timeout, etc.
        handle_error_status_code:   Pass a function that will take response as argument
                                    and handles non 2XX status
        """
        try:
            request_start_time = time.time()
            logger.info(f"Calling {url} on behalf of function '{inspect.currentframe().f_back.f_code.co_name}'"
                        f"with payload:{kwargs.get('data') or kwargs.get('json')}")
            response = requests_og.request(method=method.lower(), url=url, **kwargs)
            logger.info(f"Took {time.time() - request_start_time}sec to call {url},"
                        f"Got status code {response.status_code}")

            if response.status_code is None:
                logger.info(f"Unable to reach URL {url}")
                raise requests_og.exceptions.ConnectionError()
            elif response.ok:
                logger.info(f"[Success] url:{url} response:{response.text}")
                response = self.transform_to_dict(response.text)
                return response
            elif handle_error_status_code is not None:
                return handle_error_status_code(response)
            elif response.status_code == 408:
                raise requests_og.exceptions.Timeout()
            else:
                raise requests_og.exceptions.HTTPError()
        except requests_og.exceptions.Timeout as errt:
            logger.exception(f"[Error] {errt} url:{url}")
            raise
        except (requests_og.exceptions.ConnectionError, requests_og.exceptions.HTTPError) as errc:
            logger.exception(f"[Error] {errc} url:{url}")
            raise
        except Exception as err:
            logger.exception(f"[Error] {err} url:{url}")
            raise

    @staticmethod
    def transform_to_dict(data):
        try:
            return json.loads(data)
        except ValueError:
            try:
                return xmltodict.parse(re.sub(r'xmlns:[^>]*|nsd+:|SOAP:', '', data))
            except:
                return data

    def get_final_response(self, **kwargs):
        final_response = {
            **kwargs,
            **self.output_data,
            'conversation_details': self.conversation_details,
            'user_details': self.user_details
        }
        logger.info(f"final_response {final_response}")
        return {'statusCode': 200, 'body': json.dumps(final_response), 'headers': {'Content-Type': 'application/json'}}


class APIDataError(Exception):
    pass`;

// TODO: REMOVE THIS CHECK WHEN REMOVING CODE EDITOR OUT OF STATIC NODE
export const INIT_CODE_STATIC_NODE = `
import  json

def main(event, context):
    """
   event['body'] is a string dict with the following keys:
   node, event, user, entities.

   Currently, we pass user_id, user_name, full_name, device_platform and language_code in the user dictionary.

   Args:
       event (dict): Data corresponding to this event
       context

   Returns
       (dict): response with statusCode and the response for the User
   """
    body = json.loads(event['body'])
    entities = body['entities']
    user_data = body['user']
    final_response = {'status': True, 'response': write_here()}
    response = {'statusCode': 200, 'body': json.dumps(final_response), 'headers': {'Content-Type': 'application/json'}}
    return response

def write_here(*args):
    """
   WRITE YOUR CODE HERE and update the final_response dict
   """
    # hsl_list = ['Hello', {}]
    button_hsl = {
        "text": "COMPLETE BLOOD COUNT; CBC",
        "type": "BUTTON",
        "data": {
            "items": [
                {
                    "actionable_text": "View Price",
                    "location_required": False,
                    "is_default": 0,
                    "uri": "LAUNCH_CHANNEL",
                    "type": "TEXT_ONLY",
                    "payload": {
                        "gogo_message": "",
                        "message": "I want to check the price of this test"
                    }
                },
                {
                    "actionable_text": "View Details",
                    "location_required": False,
                    "is_default": 0,
                    "uri": "LINK",
                    "type": "APP_ACTION",
                    "payload": {
                        "url": "XYZ.COM",
                        "gogo_message": ""
                    }
                }
            ]
        },
        "isNew": False
    }
    return [json.dumps(button_hsl)]
`;
